import * as React from 'react'
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import { setStateModal } from '../../redux/slices/Modal/modalDeleteRecord'
import { setCurrentTreeId, setMarker } from '../../redux/slices/Map/map'
import { setEnableButton } from '../../redux/slices/Modal/enableButton'
import { Box, styled, Paper, IconButton, Stack } from '@mui/material'
import * as RT from '../../config/routeType'
//Icons
import Botton from '../BottonCustom'
import DeleteIcon from '@mui/icons-material/Delete'
import AdjustIcon from '@mui/icons-material/Adjust'
import ParkIcon from '@mui/icons-material/Park'
import CancelIcon from '@mui/icons-material/Cancel'

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN
const COLOR_POPUP = 'var(--color-green)'
const FONT_FAMILY = 'var(--font-family)'
const COLOR_SHOW = 'var(--color-green-light)'
const COLOR_MOVE = 'var(--color-secondary)'
const COLOR_WHITE = '#fffafa'
const COLOR_DELETE = 'var(--color-noProcess)'

const COLOR_LABEL = '#1B1C37'
const MIN_WIDTH_CONTENT = '15em'

const Header = styled(Paper)(() => ({
  backgroundColor: COLOR_POPUP,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '3.6em',
  paddingLeft: '16px',
  borderRadius: '0.8em 0.8em 0 0',
}))

const Text = styled('div')(() => ({
  fontFamily: FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '12px',
  textAlign: 'center',
  color: COLOR_LABEL,
}))

const styleTextHeader = {
  textAlign: 'center',
  width: '100%',
  fontWeight: 700,
  fontSize: '15px',
  lineHeight: '15px',
  color: '#fff',
}

const styleDefault = (bg, c) => ({
  color: COLOR_POPUP,
  border: `1px solid ${COLOR_POPUP}`,
  width: '100%',
  fontSize: '12px',
  '&:hover': { backgroundColor: bg, color: c },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})

const ContentOptions = ({ treeId: tId, coordinates, allOption }) => {
  let navigate = useNavigate()
  const dispatch = useDispatch()

  const { treeId: tIdP } = useParams()

  const enableButton = useSelector(state => state.enableButton.enable)
  const isOpenDrawerRight = useSelector(state => state.drawerRight.value)
  const _treeState = useSelector(state => state.treeFeatures)
  const { features: data } = _treeState.data || {}
  const treeId = tId ?? tIdP

  if (!(data || []).length) console.log('No se ha cargando las caracteristicas...')

  const handleEditTree = () => {
    dispatch(setEnableButton(true))
    navigate(`../../${RT.MANAGEMENT_TREE}/tree/${treeId}`, { replace: false })
    if (isOpenDrawerRight) {
      dispatch(show(false))
      dispatch(codeTree(null))
    }
  }

  const handleMoveTree = () => {
    navigate(`../../${RT.MANAGEMENT_TREE}/tree/${treeId}`, { replace: false })
    dispatch(
      setMarker({
        openMarker: true,
        draggable: true,
        lnglat: coordinates,
      })
    )
  }

  const handleDeleteTree = () => {
    dispatch(setStateModal(true))
    dispatch(setCurrentTreeId(treeId))
  }

  if (!Boolean(treeId)) return null

  return (
    <Box sx={{ minWidth: MIN_WIDTH_CONTENT, boxShadow: 'none' }}>
      <Header>
        <Text sx={styleTextHeader}>ACCIONES</Text>
        <IconButton
          aria-label="close"
          size="small"
          sx={{ px: 1, paddingRight: '6px', marginBottom: '10px' }}>
          <CancelIcon sx={{ fill: '#abe8ba', width: 20, height: 16 }} />
        </IconButton>
      </Header>
      <Stack spacing={1} sx={{ alignItems: 'center', py: 2, px: 1 }}>
        {!enableButton && (
          <Box sx={{ width: 150 }}>
            <Botton
              text="Editar"
              onClick={handleEditTree}
              startIcon={<ParkIcon />}
              styleButton={styleDefault(COLOR_SHOW, COLOR_WHITE)}
            />
          </Box>
        )}
        {enableButton && (
          <Box sx={{ width: 150 }}>
            <Botton
              text="Desplazar"
              onClick={handleMoveTree}
              startIcon={<AdjustIcon />}
              styleButton={styleDefault(COLOR_MOVE, '#1b1c37d1')}
            />
          </Box>
        )}
        {allOption && (
          <Box sx={{ width: 150 }}>
            <Botton
              text="Eliminar"
              onClick={handleDeleteTree}
              startIcon={<DeleteIcon />}
              styleButton={styleDefault(COLOR_DELETE, COLOR_WHITE)}
            />
          </Box>
        )}
      </Stack>
    </Box>
  )
}

export default ContentOptions
